/**
 * Custom hook for single meeting operations
 */

import {useEffect, useState} from 'react';
import {useMeetingsStore} from '@voxapilot/shared';
import {api} from '../config/firebase';
import {useUIStore} from '@voxapilot/shared';

export function useMeeting(meetingId: string) {
  const {currentMeeting, setCurrentMeeting} = useMeetingsStore();
  const {addToast} = useUIStore();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadMeeting();
  }, [meetingId]);

  const loadMeeting = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await api.meetings.getMeeting(meetingId);
      if (response.success && response.data) {
        setCurrentMeeting(response.data);
      } else {
        throw new Error(response.error?.message || 'Failed to load meeting');
      }
    } catch (err) {
      const error = err as Error;
      setError(error.message);
      addToast(error.message, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    meeting: currentMeeting,
    isLoading,
    error,
    reload: loadMeeting,
  };
}

